import { createAsyncThunk } from '@reduxjs/toolkit'
import { getHoldemGameTablesService } from 'network/services/holdemGameManagement.service'
import { getGamesListService } from 'network/services/gameSettings.service'

/** Fetches games list (id, name, status) from backend for lobby game type mapping */
export const getGamesListThunk = createAsyncThunk(
  'lobby/getGamesList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGamesListService()
      const payload = response?.data ?? response
      const games = payload?.data ?? payload
      return Array.isArray(games) ? games : (games?.games ?? games?.rows ?? [])
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch games')
    }
  }
)

const rowsFromTablesResponse = (response) => {
  const payload = response?.data ?? response
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.tables)) return payload.tables
  if (Array.isArray(payload?.rows)) return payload.rows
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

/** Fetches game tables for lobby. Pass gameId, or gameIds to merge several games into one list. */
export const getLobbyGameTablesThunk = createAsyncThunk(
  'lobby/getGameTables',
  async ({ data }, { rejectWithValue }) => {
    const fetchStartedAt = Date.now()
    try {
      const { gameIds, ...rest } = data || {}
      if (Array.isArray(gameIds) && gameIds.length) {
        const responses = await Promise.all(
          gameIds.map((gameId) => getHoldemGameTablesService({ ...rest, gameId: String(gameId) }))
        )
        const seen = new Set()
        const tables = responses.flatMap(rowsFromTablesResponse).filter((table) => {
          const key = String(table?.id ?? table?.tableId ?? '')
          if (!key || seen.has(key)) return false
          seen.add(key)
          return true
        })
        return { data: tables, fetchStartedAt }
      }

      const response = await getHoldemGameTablesService(rest)
      return { ...response, fetchStartedAt }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch game tables')
    }
  }
)
